<template>
  <div>
    <PageTitle
      title="Shop View"
      :backBtn="true"
      :editRoute="'/shop/edit/' + this.$route.params.id"
      :permission="'Customer Edit'"
    />
    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="6">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-account-convert</v-icon>
                  <span class="pl-3">Shop Details</span></v-card-title
                >
                <v-container
                  fluid
                  class="container saledetailscard"
                  style="padding: 0px"
                >
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row class="pt-0">
                        <v-col
                          cols="12"
                          sm="12"
                          md="9"
                          lg="9"
                          class="pr-5pt-1.5 pb-1 reference_number"
                        >
                          <span>{{ this.Shop.name }} </span>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" class="shoptext">
                          <v-row>
                            <v-chip
                              style="
                                color: white;
                                font-variant-caps: all-small-caps;
                                font-weight: bold;
                              "
                              text-color="white"
                              :color="getStatusColor(this.Shop.is_active)"
                              dark
                              label
                            >
                              {{ this.Shop.is_active ? 'Active' : 'Archived' }}
                            </v-chip>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Short Form </v-row>
                          <v-row>
                            {{ this.Shop.sortform }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable">
                            Acoount Open Date
                          </v-row>
                          <v-row>
                            {{
                              this.Shop.account
                                ? this.Shop.account.opened_date
                                : '---' | formatDate
                            }}
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="subtextlable"
                        >
                          <v-row> Actual Balance </v-row>
                          <v-row>
                            <v-chip
                              label
                              text-color="white"
                              style="font-weight: bold"
                              color="primary"
                              dark
                            >
                              LKR{{
                                this.Shop.account
                                  ? this.Shop.account.actual_balance
                                  : '---'
                              }}
                            </v-chip>
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="subtextlable"
                        >
                          <v-row> Available Balance </v-row>
                          <v-row>
                            <v-chip
                              label
                              text-color="white"
                              style="font-weight: bold"
                              color="primary"
                              dark
                              >LKR
                              {{
                                this.Shop.account
                                  ? this.Shop.account.available_balance
                                  : '---'
                              }}
                            </v-chip>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="4">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-city</v-icon
                  ><span class="pl-3"> Address</span>
                </v-card-title>
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Address Line 1 </v-row>
                          <v-row style="text-align: left">
                            {{
                              this.Shop.address.address_line1
                                ? this.Shop.address.address_line1
                                : '---'
                            }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Address Line 2 </v-row>
                          <v-row style="text-align: left">
                            {{
                              this.Shop.address.address_line2
                                ? this.Shop.address.address_line2
                                : '---'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> City </v-row>
                          <v-row style="text-align: left">
                            {{
                              this.Shop.address.city
                                ? this.Shop.address.city
                                : '---'
                            }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Country </v-row>
                          <v-row style="text-align: left">
                            {{
                              this.Shop.address.country
                                ? this.Shop.address.country.name
                                : '---'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="2">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-phone</v-icon
                  ><span class="pl-3"> Contact</span>
                </v-card-title>
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Phone </v-row>
                          <v-row style="text-align: left">
                            <a href="">
                              {{
                                this.Shop.contact.phone
                                  ? this.Shop.contact.phone
                                  : '---'
                              }}</a
                            >
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Telephone </v-row>
                          <v-row style="text-align: left">
                            <a href="">
                              {{
                                this.Shop.contact.telephone
                                  ? this.Shop.contact.telephone
                                  : '---'
                              }}</a
                            >
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Email </v-row>
                          <v-row style="text-align: left">
                            {{
                              this.Shop.contact.email
                                ? this.Shop.contact.email
                                : '---'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title producttiltle"
              ><v-icon color="blue" small>mdi-chart-pie</v-icon
              ><span class="ml-3"> Shop Related Factors</span>
            </v-card-title>
            <v-container fluid class="light gray lighten-12 saledetailscard">
              <v-tabs v-model="tab" background-color="primary" dark>
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="item in items" :key="item.tab">
                  {{ item.tab }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item> <StockShops /> </v-tab-item
                ><v-tab-item>
                  <SalesShop />
                </v-tab-item>
                <v-tab-item>
                  <ProductShop />
                </v-tab-item>
              </v-tabs-items>
            </v-container>
          </v-card>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title producttiltle"
              ><v-icon color="blue">mdi-content-paste</v-icon
              ><span class="ml-3">Recent Logs </span>
            </v-card-title>
            <v-container fluid class="light gray lighten-12 saledetailscard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <AuditLogs :Type="'shops'" />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import StockShops from './ShopStockComponent';
import SalesShop from './ShopSalesComponent';
import ProductShop from './ProductShop.vue';
import { required, email, max, regex } from 'vee-validate/dist/rules';
import { Address } from '../../../../../models/Address';
import { Contact } from '../../../../../models/Contact';
import Shop from '../../../../../models/Shop';
import LineChart from '@/components/Charts/ShopSaleLineChart';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});
extend('regex', {
  ...regex,
  message: 'The value is not a valid phone number',
});
export default {
  components: {
    ValidationProvider,
    SalesShop,
    StockShops,
    ValidationObserver,
    LineChart,
    ProductShop,
  },
  data() {
    return {
      account_type: '',
      Shop: new Shop(),
      items: [
        { tab: 'Stock', content: '' },
        { tab: 'Sales', content: '' },
        { tab: 'Product', content: '' },
      ],
      tab: '',
    };
  },
  created() {
    this.GetShopSingle();
  },
  methods: {
    GetShopSingle() {
      const id = this.$route.params.id;
      this.$store
        .dispatch(`shop/GetShopSingleId`, id)
        .then((res) => {
          this.Shop = res.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 25px;
}
.status {
  font-weight: bold;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
</style>
